"use strict";
const angular = require("angular");

/*@ngInject*/
export function passwordService() {
  // AngularJS will instantiate a singleton by calling "new" on this function
  "ngInject";
  return {
    getStrength(pass) {
      var tests = [/[0-9]/, /[a-z]/, /[A-Z]/, /[^A-Z-0-9]/i];
      if (pass === null || !pass) {
        return -1;
      }
      var s = 0;
      if (pass.length < 7) {
        return 0;
      }
      for (var i in tests) {
        if (tests[i].test(pass)) {
          s++;
        }
      }
      return s;
    },
  };
}

export default angular
  .module("dalApp.pass", [])
  .service("PasswordService", passwordService).name;



// WEBPACK FOOTER //
// ./client/app/account/password.service.js